module.exports = __webpack_public_path__ + "static/img/logo.8e1c690f.png";